import { Grid } from '@material-ui/core';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import React, { useEffect, useState } from 'react'
import { ButtonHLPure, HeaderHLPure } from '../../../pures';
import { useTranslation } from 'react-i18next';
import InputPureWrapper from './inputs/inputPureWrapper'
import DropdownWrapper from './inputs/dropdownWrapper'
import ComboboxWrapper from './inputs/comboboxWrapper'
import TextAreaWrapper from './inputs/textareaWrapper'
import { RegistrationValidator } from '../../../../validators';
import { CatalogService, LocalStorageService } from '../../../../services'


const url = process.env.REACT_APP_ETICKET_API;
const catalogService = new CatalogService(url);
const localStorageService = new LocalStorageService();

let token = localStorageService.getLocalStorageItem("token")
if (token) token = token.idToken

function CompanyDataForm(props) {
    const {
        moveStep,
        onSubmitStep,
        catalog
    } = props;

    const [statesByCountry, setStatesByCountry] = useState([])

    const getStatesByCountryId = async () => {
        if (country) {
            const resultCountry = await catalogService.getCountryGeonameId(country, token)
            console.log(resultCountry)

            const data = await catalogService.getCatalogStatesByGeonameId(resultCountry.geonameId || '3996063', token)
            setStatesByCountry(data)
        }
    }

    const getMarketNichesByEconomicSector = async () => {
        if (economicSectorSelected) {
            const marketNichesFound = await catalogService.getMarketNicheByEconomicSector(economicSectorSelected.id, token)

            const marketNichesSelected = marketNichesFound.map((marketNiche) => {
                return { id: marketNiche.id, name: tCommon(marketNiche.name.trim()) }
            })
            setMarketNiche(marketNichesSelected)
        }
    }

    const { t } = useTranslation();
    const { t: tCommon, ready, i18n } = useTranslation('common');
    const validator = RegistrationValidator(t);

    const countryOptions = [t('register.country.mx'), t('register.country.can'), t('register.country.usa')]

    const { economicSector, numEmployeesOption, numUsersAppOption, regimeOption, marketNicheOption } = catalog;

    const [economicSectorAux, setEconomicSectorAux] = useState([])
    const [numEmployeesOptionAux, setNumEmployeesOptionAux] = useState([])
    const [numUsersAppOptionAux, setNumUsersAppOptionAux] = useState([])
    const [regimeOptionAux, setRegimeOptionAux] = useState([])
    const [marketNiche, setMarketNiche] = useState([])
    const [country, setCountry] = useState('')
    const [economicSectorSelected, setEconomicSectorSelected] = useState('')

    useEffect(() => {
        getStatesByCountryId()
    }, [country])

    useEffect(() => {
        getMarketNichesByEconomicSector()
    }, [economicSectorSelected])

    useEffect(() => {
        const economicSectorSelected = economicSector.map((economicSec) => {
            return { id: economicSec.id, name: tCommon(economicSec.name.trim()) }
        })

        const numEmployeeSelected = numEmployeesOption.map((numEmployee) => {
            return { id: numEmployee.id, name: tCommon(numEmployee.name.trim()) }
        })

        const numUserAppSelected = numUsersAppOption.map((numUserAction) => {
            return { id: numUserAction.id, name: tCommon(numUserAction.name.trim()) }
        })

        const regimeSelected = regimeOption.map((regimeOpt) => {
            return { id: regimeOpt.id, name: tCommon(regimeOpt.name.trim()) }
        })

        const marketNichesSelected = marketNicheOption.map((marketNiche) => {
            return { id: marketNiche.id, name: tCommon(marketNiche.name.trim()) }
        })

        setEconomicSectorAux(economicSectorSelected)
        setNumEmployeesOptionAux(numEmployeeSelected)
        setNumUsersAppOptionAux(numUserAppSelected)
        setRegimeOptionAux(regimeSelected)
        setMarketNiche(marketNichesSelected)
    }, [i18n.language, ready])

    return (
        <Form
            onSubmit={onSubmitStep}
            render={(formRenderProps) => {
                return (
                    <FormElement>
                        <Grid container className='companyDataForm' spacing={3}>
                            <Grid item xs={12}>
                                <HeaderHLPure title={t("registration.action.companyInformation")} headingNumber={2} />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="name"
                                    name={'name'}
                                    component={InputPureWrapper}
                                    label={`${t('register.invoiceData.name')} *`}
                                    validator={validator.requiredValidator}
                                />
                            </Grid>

                            <Grid item xs={12} md={i18n.language === 'es-MX' ? 12 : 6}>
                                <Field
                                    id="numEmployees"
                                    name={'numEmployees'}
                                    label={`${t('register.companyData.employeeNumbers')} *`}
                                    component={DropdownWrapper}
                                    data={numEmployeesOptionAux}
                                    dataItemKey="id"
                                    textField="name"
                                    validator={validator.requiredValidator}
                                />
                            </Grid>

                            <Grid item xs={12} md={i18n.language === 'es-MX' ? 12 : 6}>
                                <Field
                                    id="numUsers"
                                    name={'numUsers'}
                                    label={`${t('register.companyData.applicationUsersNumber')} *`}
                                    component={DropdownWrapper}
                                    data={numUsersAppOptionAux}
                                    dataItemKey="id"
                                    textField="name"
                                    validator={validator.requiredValidator}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Field
                                    id="economicSector"
                                    name={'economicSector'}
                                    label={`${t('register.companyData.economicSector')} *`}
                                    component={DropdownWrapper}
                                    data={economicSectorAux}
                                    dataItemKey="id"
                                    textField="name"
                                    validator={validator.requiredValidator}
                                    onChange={(ev) => { setEconomicSectorSelected(ev.target.value) }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Field
                                    id="marketNiche"
                                    name={'marketNiche'}
                                    label={`${t('register.companyData.marketNiche')} *`}
                                    component={DropdownWrapper}
                                    data={marketNiche}
                                    dataItemKey="id"
                                    textField="name"
                                    validator={validator.requiredValidator}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="description"
                                    name={'description'}
                                    component={TextAreaWrapper}
                                    label={`${t('register.companyData.activityDescription')} *`}
                                    validator={validator.requiredValidator}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} style={{ marginTop: '35px' }}>
                                <Field
                                    id="street"
                                    name={'street'}
                                    component={InputPureWrapper}
                                    label={t('register.fiscalData.street')}
                                // validator={validator.suburbValidator}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} style={{ marginTop: '35px' }}>
                                <Field
                                    id="suburb"
                                    name={'suburb'}
                                    component={InputPureWrapper}
                                    label={t('register.address.suburb')}
                                // validator={validator.suburbValidator}
                                />
                            </Grid>

                            {
                                i18n.language === 'es-MX' ? <Grid item xs={12} md={6}>
                                    <Field
                                        id="municipality"
                                        name={'municipality'}
                                        component={InputPureWrapper}
                                        label={t('register.fiscalData.municipality')}
                                    // validator={validator.municipalityValidator}
                                    />
                                </Grid> : <Grid item xs={12} md={6}>
                                    <Field
                                        id="city"
                                        name={'city'}
                                        component={InputPureWrapper}
                                        label={t('register.fiscalData.location')}
                                    // validator={validator.townValidator}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} md={6}>
                                <Field
                                    id="postalCode"
                                    name={'postalCode'}
                                    component={InputPureWrapper}
                                    label={t('register.address.zipCode')}
                                    validator={(value) => validator.zipCodeValidator(value, formRenderProps.valueGetter('country'))}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    id="country"
                                    name={'country'}
                                    label={t('register.fiscalData.country')}
                                    component={DropdownWrapper}
                                    data={countryOptions}
                                    validator={validator.requiredValidator}
                                    onChange={(ev) => { setCountry(ev.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    style={{ height: '35px' }}
                                    id="state"
                                    name={'state'}
                                    component={ComboboxWrapper}
                                    data={statesByCountry}
                                    label={t('register.fiscalData.federalEntity')}
                                // validator={validator.stateValidator}
                                />
                            </Grid>
                            <Grid item xs={12} className='onboardingView-actions'>
                                <ButtonHLPure colorScheme="error" outlined nameBtn={tCommon("back")} onClick={() => moveStep(false)} />
                                <ButtonHLPure type="submit" colorScheme="primary" outlined nameBtn={tCommon("continue")} />
                            </Grid>
                        </Grid>
                    </FormElement>
                )
            }}
        />
    )
}

export default CompanyDataForm